import React from "react";
import styled from "styled-components";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import StreamsAndCategoriesFilter from "views/components/common/StreamsAndCategoriesFilter";
const Container = styled.div`
  flex: 1;
  grid-area: streams;
`;
const StreamsFilter = ({
  disabled = false,
  value = { streams: [], categories: [] },
  streams,
  streamCategories,
  onChange,
  multi = true,
  clearable = true
}) => {
  const sendTelemetry = useSendTelemetry();
  const placeholder = "Select streams the search should include. Searches in all streams if empty.";
  const handleChange = (selected) => {
    var _a;
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_STREAM_INPUT_CHANGED, {
      app_pathname: "search",
      app_section: "search-bar",
      app_action_value: "search-filter",
      event_details: {
        streamsCount: (_a = selected == null ? void 0 : selected.streams) == null ? void 0 : _a.length
      }
    });
    onChange(selected);
  };
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "streams-filter", title: placeholder }, /* @__PURE__ */ React.createElement(
    StreamsAndCategoriesFilter,
    {
      placeholder,
      disabled,
      clearable,
      "aria-label": placeholder,
      inputId: "streams-filter",
      onChange: handleChange,
      streams: streams.map((v) => ({ id: v.value, title: v.key, categories: [] })),
      streamCategories: streamCategories.map((v) => v.value),
      multi,
      value,
      required: false
    }
  ));
};
export default StreamsFilter;
